import React from 'react';
import { Landing } from './pages/Landing';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <Landing data-id="element-1" />
    </>;
}